import { ActionIcon, Checkbox as MantineCheckbox, TextInput } from '@mantine/core';
import type { PartialTableTheme } from 'schummar-table';

export default {
  colors: {
    background: 'var(--mantine-color-paper-7)',
    text: 'inherit',
    border: 'var(--mantine-color-paper-9)',
    borderLight: 'var(--mantine-color-paper-8)',
  },
  components: {
    Checkbox(props) {
      return (
        <MantineCheckbox
          {...props}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      );
    },

    TextField({ value, startIcon, endIcon, inputRef, ...props }) {
      return <TextInput {...props} value={value ?? ''} leftSection={startIcon} rightSection={endIcon} ref={inputRef} />;
    },

    IconButton: ActionIcon,
  },
} satisfies PartialTableTheme;
